const getItem = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

const setItem = (key, value) => {
  try {
    return localStorage.setItem(key, value);
  } catch (e) {
    return null;
  }
};

const removeItem = (key) => {
  try {
    return localStorage.removeItem(key);
  } catch (e) {
    return null;
  }
};

export const local = {
  getItem,
  setItem,
  removeItem,
};
